<template>
<b-container fluid class="container">
   <b-row class="justify-content-md-center">
          <b-col col md="3" class="text-center">
           <Descripcion/>
            <div class="mb-5" >
                  <img src="../assets/wizard2.png" class="img-fluid" alt="" />
            </div>
            <hr>
            <div class="mb-5">
              <h6>Estamos para ayudarte</h6>
              <p style="font-size: 15px">¿Deseas ser asistido por uno de nuestros asesores?</p>
                  <b-button @click.prevent="" variant="outline-primary" class="button_H11">ESTAMOS PARA AYUDARTE</b-button>
            </div>
          </b-col>
          <b-col  col md="9" class="card-body text-center">
            <Sesion/>
            <h1 class="mt-5" style="color: #111111" >Realiza un pago de <span style="color: #B3DB5A">${{this.monto}}</span> para apartarlo</h1>
            <h5 style="font-weight: bold;" class="mt-3">Apartado 100% reembolsable.</h5>
            <h5 style="font-weight: bold;" class="mt-3">Inicia sesión o Regístrate para continuar con el proceso.</h5>

            <b-card v-if="this.continuar != 'true'" border-variant="light" class="mt-3">
                <b-row class="mt-5">
                    <div class="col-md-6">
                    <b-col>
                      <b-button @click.prevent="sesion()" class="button_H1">INICIAR SESIÓN</b-button>
                    </b-col>
                    </div>
                    <div class="col-md-6">
                    <b-col>
                      <b-button @click.prevent="registro()" class="button_H1">CREAR USUARIO</b-button>
                    </b-col>
                    </div>
                </b-row>
                <b-row align-h="center" class="justify-content-md-center m-auto">
                  <b-col md="6" lg="6" sm="6" class="mt-2 rounded">
                      <b-button @click.prevent="regresar()" class="button_H">REGRESAR</b-button>
                  </b-col>
                </b-row>
            </b-card>

            <b-card v-if="this.continuar == 'true'" border-variant="light" class="mt-3">
                <b-row class="mt-5">
                    <div class="col-md-6">
                    <b-col>
                      <b-button @click.prevent="codigoAcceso()" variant="outline-primary" class="button_H1">CONTINUAR CON TU RESERVA</b-button>
                    </b-col>
                    </div>
                    <div class="col-md-6">
                    <b-col>
                      <b-button @click.prevent="regresar()" variant="primary" class="button_H">REGRESAR</b-button>
                    </b-col>
                    </div>
                </b-row>
            </b-card>

          </b-col>
   </b-row>


   <!-- Modal de Sesión -->
      <b-modal v-model="access" hide-footer header-bg-variant="danger" headerTextVariant="light">
      <b-container fluid>
        <b-row cols="1" class="mb-1 justify-content-md-center">
          <b-col cols="12" class="text-center"><h1>Bienvenido</h1> </b-col>
          <b-col cols="12" class="text-center"><p style="font-size: 13px">Ingresa tu usuario y contraseña</p> </b-col>
          <div class="col-md-9">
            <b-col>
              <b-form-input type="text" class="inputModal" v-model="usuario" placeholder="Usuario" maxlength="26" required></b-form-input>
            </b-col>
          </div>
          <div class="col-md-9 mt-3">
            <b-col>
              <div class="input-group mb-3">
                <b-form-input id="password" type="password" class="inputModal" v-model="contrasenia" placeholder="Contraseña" maxlength="26" required></b-form-input>
                <b-button @click.prevent="mostrarContrasena()" class="button_pass"><b-icon icon="eye" aria-hidden="true"></b-icon></b-button>  
              </div>
            </b-col>
          </div>

          <b-col v-if="this.errorLogin == true" cols="12" class="mt-3 text-center">
              <p style="color: red" >{{this.merror}}</p>
          </b-col>

          <b-col cols="12" class="mt-3 text-center">
            <b-form-checkbox id="checkbox-3" name="checkbox-3" value="accepted" unchecked-value="not_accepted">
            Recordar Siempre
          </b-form-checkbox>
          </b-col>
          <b-col class="mt-3">
            <b-button @click.prevent="iniciar()" variant="danger" class="button_H">INICIAR SESIÓN</b-button>
          </b-col>
          <b-col cols="12" class="text-center">
            <b-button @click.prevent="recover()" style="color: #0080FF" variant="link">¿OLVIDASTE TU CONTRASEÑA?</b-button>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
   <!-- Modal de Sesión -->

</b-container>
</template>

<script>
import Sesion from './Sesion.vue'
import Descripcion from './Descripcion.vue';

export default {
  name: 'Reserva',

  components: {
    Sesion,
    Descripcion
  },

    data() {
    return {
      vin: sessionStorage.getItem("vin"),
      type: sessionStorage.getItem("type"),
      errorLogin: '',
      merror: '',
      continuar: sessionStorage.getItem("continuar"),
      contents: null,
      monto: sessionStorage.getItem("montoWeb"),
      usuario: '',
      contrasenia: '',
      access:false,
      session: '',
      telefono: sessionStorage.getItem("telefono"),
      mail: sessionStorage.getItem("mail")
      };
  },

  methods: {
        onSubmit(event) {
            event.preventDefault();
        },

        onReset(event) {
            window.history.go(-2);
        },

        registro(){
          this.$router.push({ path: '/Registro'});
        },

        sesion(){
          this.access= true;
        },

        iniciado(){
          this.access = false;
        },

        iniciar(){
            let userTk = {
            username: "marco.villegas@autocom.mx",
            //password: "B8jc8q!n"}; //qa
            password: "Asd12345"}; //prod
            axios.post("https://qasrv-login.autocom.mx/api/Token/login", userTk)
              .then((response) => {
                this.contents = response.data.token;
                sessionStorage.setItem("tknUser", response.data.token);
                this.login();
              });
        },

        login(){

          if(this.usuario != '' && this.contrasenia != '') {
              let user = {
                  username: this.usuario,
                  password: this.contrasenia,
                  app: 'Reservas',
              }

            axios.post('https://qasrv-login.autocom.mx/api/Customer/IdentifyCustomer', user,  {
              headers: {
              Authorization: "Bearer " + sessionStorage.getItem("tknUser"),
              'Content-Type': 'application/json',
              }, 
              }).then(response =>{
                this.acceso = response.data.status;
                if (this.acceso == 'success'){
                    this.session = response.data.qisId;
                    sessionStorage.setItem("nombre", response.data.customerName);
                    sessionStorage.setItem("paterno", response.data.customerSurname);
                    sessionStorage.setItem("materno", response.data.customerSurname2);
                    sessionStorage.setItem("mail", response.data.customerEmail);
                    sessionStorage.setItem("telefono", response.data.customerPhone);
                    sessionStorage.setItem("loginAct", this.session);
                    sessionStorage.setItem("session", this.session);
                    this.continuar = true;
                    sessionStorage.setItem("continuar", this.continuar);
                    this.refresh();
                    this.access = false;
                } else {
                  this.errorLogin = true;
                  this.merror = response.data.message;
                }
              }).catch(error=>{
                  console.log(error)
              });
           } else { 
                  this.errorLogin = true;
                  this.merror = 'Se requiere de un usuario y una contraseña';
           }
        },

        refresh(){
          location.reload();
        },

        regresar(){
          this.$router.push({ path: '/Bienvenida'});          
        },

        recover(){
          this.$router.push({ path: '/Recover'});
        },

        codigoAcceso() {
          this.codigoReserva = Math.floor(100000 + Math.random() * 900000);
          sessionStorage.setItem("codigoReserva", this.codigoReserva); 
          this.$router.push({ path: '/Codigo'});
          this.cargarToken();
          return this.codigo;
        },

        cargarToken(){
            let user = {username: "manuel.avila@autocom.mx", password: "Laundecima11"};
            axios.post("https://qasrv-notificaciones.autocom.mx/api/token/login", user)
            .then((response) => {
              //console.log("token stock-->", response.data.token);
              sessionStorage.setItem("tokenMensaje", response.data.token);
              this.enviaSMS();
              this.enviaMail();
            }).catch(error => {
                console.log('Algo salio mal SMS--->',error)
            });
        },
        enviaSMS(){
          let body = {
              phone: this.telefono, 
              user: "reservas@autocom.mx",
              subject:"CODIGO NISSAN AUTOCOM",
              aplication:"Reservas",
              body:`SMS TU CODIGO DE CONFIRMACION ES ${this.codigoReserva}`,
            };
          axios.post("https://qasrv-notificaciones.autocom.mx/api/smsSend",body, {
            headers: {
              Authorization: "Bearer " + sessionStorage.getItem("tokenMensaje"),
              'Content-Type': 'application/json',
            },
          })
          .then((response) => {
              console.log('SMS --->', response.status)
          }).catch(error => {
              console.log('Algo salio mal SMS--->',error)
          });
        },

      enviaMail(){
                  console.log('Body --->',this.mail);
        let mail = {
            to:this.mail, 
            // toCopy:"josescalante@gmail.com",
            user:"desarrolloti@autocom.mx",
            aplication:"sitioWeb",
            subject:"CODIGO DE VERIFICACION RESERVAS AUTOCOM",
            body:`
                <!DOCTYPE HTML PUBLIC "-//W3C//DTD HTML 4.01 Transitional//EN" "http://www.w3.org/TR/html4/loose.dtd">
                <html>
                <head>
                <meta http-equiv="Content-Type" content="text/html; charset=utf-8">
                <!-- utf-8 works for most cases -->
                <meta name="viewport" content="width=device-width">
                <!-- Forcing initial-scale shouldn't be necessary -->
                <meta http-equiv="X-UA-Compatible" content="IE=edge">
                <!-- Use the latest (edge) version of IE rendering engine -->
                <title>Codigo verificacion</title>
                <!-- The title tag shows in email notifications, like Android 4.4. -->

                <!-- Please use an inliner tool to convert all CSS to inline as inpage or external CSS is removed by email clients -->
                <!-- important in CSS is used to prevent the styles of currently inline CSS from overriding the ones mentioned in media queries when corresponding screen sizes are encountered -->

                <!-- CSS Reset -->
                <style type="text/css">
                /* What it does: Remove spaces around the email design added by some email clients. */
                      /* Beware: It can remove the padding / margin and add a background color to the compose a reply window. */
                html, body {
                  margin: 0 !important;
                  padding: 0 !important;
                  height: 100% !important;
                  width: 100% !important;
                }
                /* What it does: Stops email clients resizing small text. */
                * {
                  -ms-text-size-adjust: 100%;
                  -webkit-text-size-adjust: 100%;
                }
                /* What it does: Forces Outlook.com to display emails full width. */
                .ExternalClass {
                  width: 100%;
                }
                /* What is does: Centers email on Android 4.4 */
                div[style*="margin: 16px 0"] {
                  margin: 0 !important;
                }
                /* What it does: Stops Outlook from adding extra spacing to tables. */
                table, td {
                  mso-table-lspace: 0pt !important;
                  mso-table-rspace: 0pt !important;
                }
                /* What it does: Fixes webkit padding issue. Fix for Yahoo mail table alignment bug. Applies table-layout to the first 2 tables then removes for anything nested deeper. */
                table {
                  border-spacing: 0 !important;
                  border-collapse: collapse !important;
                  table-layout: fixed !important;
                  margin: 0 auto !important;
                }
                table table table {
                  table-layout: auto;
                }
                /* What it does: Uses a better rendering method when resizing images in IE. */
                img {
                  -ms-interpolation-mode: bicubic;
                }
                /* What it does: Overrides styles added when Yahoo's auto-senses a link. */
                .yshortcuts a {
                  border-bottom: none !important;
                }
                /* What it does: Another work-around for iOS meddling in triggered links. */
                a[x-apple-data-detectors] {
                  color: inherit !important;
                }
                </style>

                <!-- Progressive Enhancements -->
                <style type="text/css">
                /* What it does: Hover styles for buttons */
                .button-td, .button-a {
                  transition: all 100ms ease-in;
                }
                .button-td:hover, .button-a:hover {
                  background: #A50932 !important;
                  border-color: #A50932 !important;
                }

                /* Media Queries */
                @media screen and (max-width: 480px) {
                /* What it does: Forces elements to resize to the full width of their container. Useful for resizing images beyond their max-width. */
                .fluid, .fluid-centered {
                  width: 100% !important;
                  max-width: 100% !important;
                  height: auto !important;
                  margin-left: auto !important;
                  margin-right: auto !important;
                }
                /* And center justify these ones. */
                .fluid-centered {
                  margin-left: auto !important;
                  margin-right: auto !important;
                }
                /* What it does: Forces table cells into full-width rows. */
                .stack-column, .stack-column-center {
                  display: block !important;
                  width: 100% !important;
                  max-width: 100% !important;
                  direction: ltr !important;
                }
                /* And center justify these ones. */
                .stack-column-center {
                  text-align: center !important;
                }
                /* What it does: Generic utility class for centering. Useful for images, buttons, and nested tables. */
                .center-on-narrow {
                  text-align: center !important;
                  display: block !important;
                  margin-left: auto !important;
                  margin-right: auto !important;
                  float: none !important;
                }
                table.center-on-narrow {
                  display: inline-block !important;
                }
                }
                </style>
                </head>
                <body width="100%" bgcolor="#e0e0e0" style="margin: 0;" yahoo="yahoo">
                <table cellpadding="0" cellspacing="0" border="0" height="100%" width="100%" bgcolor="#e0e0e0" style="border-collapse:collapse;">
                  <tr>
                    <td><center style="width: 100%;">
                        
                        <!-- Visually Hidden Preheader Text : BEGIN -->
                        <div style="display:none;font-size:1px;line-height:1px;max-height:0px;max-width:0px;opacity:0;overflow:hidden;mso-hide:all;font-family: sans-serif;"> Este es tu código de confirmación </div>
                        <!-- Visually Hidden Preheader Text : END -->
                        
                        <div style="max-width: 680px;"> 
                          <!--[if (gte mso 9)|(IE)]>
                            <table cellspacing="0" cellpadding="0" border="0" width="680" align="center">
                            <tr>
                            <td>
                            <![endif]--> 
                          
                          <!-- Email Header : BEGIN -->
                          <table cellspacing="0" cellpadding="0" border="0" align="center" width="100%" style="max-width: 680px;">
                            <tr>
                              <td style="padding: 20px 0; text-align: center; background-color: #333333;"><img src="https://www.autocom.mx/static/dealer-19673/logo.png" width="200" alt="AUTOCOM" border="0"  ></td>
                            </tr>
                          </table>
                          <!-- Email Header : END --> 
                          
                          <!-- Email Body : BEGIN -->
                          <table cellspacing="0" cellpadding="0" border="0" align="center" bgcolor="#ffffff" width="100%" style="max-width: 680px;">
                            
                          <!-- 1 Column Text : BEGIN -->
                            <tr>
                              <td><table cellspacing="0" cellpadding="0" border="0" width="100%">
                                  <tr>
                                    <td style="padding: 40px; text-align: center; font-family: sans-serif; font-size: 15px; mso-height-rule: exactly; line-height: 20px; color: #555555;"> 
                                      <h1 style="font-size:25px;margin:0 0 20px 0;text-align: center;font-family:Open Sans,sans-serif;">Este es tu código de confirmación</h1>
                                      <h1 style="font-size:25px;margin:0 0 20px 0;line-height: 22.52px;text-align: center;font-family:Open Sans,sans-serif;color: #000000;">${this.codigoReserva}</h1>
                                  </tr>
                                </table></td>
                            </tr>

                    
                          <!--[if (gte mso 9)|(IE)]>
                            </td>
                            </tr>
                            </table>
                            <![endif]--> 
                        </div>
                      </center></td>
                  </tr>
                </table>
                </body>
                </html>`};

        axios.post("https://qasrv-notificaciones.autocom.mx/api/emailSend",mail, {
          headers: {
            Authorization: "Bearer " + sessionStorage.getItem("tokenMensaje"),
            'Content-Type': 'application/json',
          },
  
        })
        .then((response) => {
            console.log('Email --->', response.status)
        }).catch(error => {
            console.log('Algo salio mal--->',error)
        });
      },

        formatPrice(value) {
            let val = (value/1).toFixed(0).replace('.', '.')
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        },

        formatPriceCostos(value) {
            let val = (value/1).toFixed(2).replace('.', '.')
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        },
        mostrarContrasena(){
              var tipo = document.getElementById("password");
              if(tipo.type == "password"){
                  tipo.type = "text";
              }else{
                  tipo.type = "password";
              }
        },

    datos(){
      console.log('Engtrando a datos Reserva --> ',this.vin +' '+this.type);
      if( this.vin == 'undefined' && this.type == 'undefined'){
        sessionStorage.setItem("vin", this.$route.query.vin);
        sessionStorage.setItem("type", this.$route.query.type);
      }

      if( this.vin == null && this.type == null){
        sessionStorage.setItem("vin", this.$route.query.vin);
        sessionStorage.setItem("type", this.$route.query.type);
      }
   
    }
  },
  
  created() {
    this.iniciado();
    this.datos();
  },

}
</script>

<style scoped>


</style>